import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';
import ArticleCard from '@/components/feature/ArticleCard';

export default function LatestArticles() {
  const latestArticles = articles.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());

  const getCategoryName = (slug: string) => {
    const cat = categories.find((c) => c.slug === slug);
    return cat ? cat.name : slug;
  };

  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="mb-8 md:mb-10">
          <h2 className="text-xl md:text-2xl font-heading text-foreground-950 mb-2">
            最新历史事件
          </h2>
          <p className="text-sm text-foreground-600">
            按时间线浏览最新收录的重大历史事件，把握历史脉络
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {latestArticles.map((article) => (
            <ArticleCard
              key={article.id}
              id={article.id}
              title={article.title}
              summary={article.summary}
              category={article.category}
              categoryName={getCategoryName(article.category)}
              date={article.date}
              readTime={article.readTime}
              imageUrl={article.imageUrl}
              tags={article.tags}
            />
          ))}
        </div>
      </div>
    </section>
  );
}